import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import Button from 'js/components/shared/Button';

import styles from './RoomHeader.module.scss'

const cx = classnames.bind(styles)

const RoomHeader = ({
  title, removeAnchor, roomsCount, roomId, onRemoveClick,
}) => (
  <div className={cx('room-header', {'more-then-one': roomsCount > 1})}>
    <div className={cx('title')}>
      {title}
    </div>
    {roomsCount > 1 && (
      <Button theme="link" size="sm" className={cx('remove-link')} onClick={onRemoveClick(roomId)}>
        {removeAnchor}
      </Button>
    )}
  </div>
)

RoomHeader.propTypes = {
  title: PropTypes.string.isRequired,
  removeAnchor: PropTypes.string.isRequired,
  roomsCount: PropTypes.number.isRequired,
  roomId: PropTypes.string.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
}

export default RoomHeader
